import script from "./ProductsPDVCommons.vue?vue&type=script&lang=js"
export * from "./ProductsPDVCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__